<!-- class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0" -->
<section class="flex flex-col lg:flex-row w-full p-2 h-full overflow-auto gap-4">
  
  <div class="lg:basis-2/5 w-full">
    <!-- class="max-w-2xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg" -->
    <div
      class="p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
      <div class="max-w-5xl flex flex-col gap-8">
        <div class="card divide-y divide-main-base flex flex-col gap-8">
          <div>
  
            <div class="flex justify-between">
              <h3 class="text-lg font-medium leading-6 text-main-dark">
                Parse Trips
              </h3>
              <div  class="flex items-center gap-1 border border-dashed rounded-md px-2 py-0.5">
  
                <a class="flex items-center gap-1 text-sm" href="../../../../../../assets/sample-trips.xlsx" download>
                  
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="h-4 w-5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                </svg>
                  Template File</a>
              </div>
  
            </div>
  
            <!-- --fundingsource-- -->
            <div class="space-y-1 mt-6">
              <label for="fundingSource" class="subheading">Funding Source</label>
              <div class="mt-1">
                <ng-select id="fundingSource" [(ngModel)]="selFundSrc" [clearable]="false" class="">
                  <ng-option value=""> Select Funding Source</ng-option>
                  <ng-option *ngFor="let fundingSource of fundingSources" value="{{ fundingSource.id }}">{{fundingSource.title | titlecase}}
                  </ng-option>
                </ng-select>
              </div>
            </div>
  
            <div class="mt-6">
              <div>
                <label for="role-type" class="block text-sm font-medium text-main-secondary">Trips File <span class="text-red-600">*</span></label>
                <div class="mt-1">
  
                  <div class="flex justify-center rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6">
                    <div class="space-y-1 text-center">
                      <svg *ngIf="selectedFile === null" class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor"
                        fill="none" viewBox="0 0 48 48" aria-hidden="true">
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <div class="flex text-sm text-gray-600">
                        <label for="customFile"
                          class="relative cursor-pointer rounded-md bg-white font-medium text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:text-indigo-500">
                          <span *ngIf="selectedFile === null">Upload a file</span>
                          <!-- <p *ngIf="selectedFile === null" class="text-xs text-gray-500">
                                Upload .txt file
                              </p> -->
                          <input type="file" #fileInput (change)="onFileSelection($event)" id="customFile"
                            name="file-upload" class="sr-only"   accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                          <label *ngIf="selectedFile !== null" for="customFile">{{selectedFile.name}}</label>
                        </label>
                        <div>
                          <button *ngIf="selectedFile" (click)="deleteFile(fileInput)"
                            class="p-1 btn btn-danger rounded-full -top-2.5 -right-2.5 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                              stroke="currentColor" class="size-4">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-2 text-red-600 text-xs" *ngIf="selectedFile === null && submitted">
                  <p class="mt-2 text-red-600 text-xs">
                    Trips File is required
                  </p>
                </div>
                <div class="mt-2 text-red-600 text-xs" *ngIf="invalidFileType && submitted">
                  <div>
                    text-center file format is required
                  </div>
                </div>
                <div class="mt-2 text-xs text-main-danger">
                  <div>
                    Excel, CSV, or Sheet file format is required.
                  </div>
                </div>
  
                <div class="sm:col-span-6 flex justify-end">
                  <button type="button" class="ml-3 btn btn-secondary" (click)="submitFile()">Proceed</button>
  
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="skippedTrips?.length"
    class="flex-1 w-full overflow-hidden rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg p-3">
    <h3 class="text-lg font-medium leading-6 text-main-dark mb-2">
      Unparsed Trips <span class="text-sm text-gray-400">({{ skippedTrips.length}})</span>
    </h3>
    <div
      class="h-[calc(100%-28px)] w-full overflow-x-auto rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
      <div class="overflow-x-auto rounded-lg"></div>
      <table class="able-auto w-full border-collapse border border-zinc-950/10 dark:border-white/10 rounded">
        <thead class="bg-zinc-950/5 dark:bg-white/5">
          <tr>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Name
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Contact No.
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Email
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Pickup Time
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Pickup Address
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Dropff Time
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Dropoff Address
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Appointment Type
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Space Type
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Miles
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Escorts
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Private Notes
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              General Notes
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Requestor Name
            </th>
            <th
              class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Reason
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10" *ngFor="let item of skippedTrips">
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{(item.data?.name) | titlecase}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.data?.contactNumber}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.data?.email}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.data?.pickupTime}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.data?.pickupAddress}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.data?.destinationTime}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.data?.destinationAddress}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              <span *ngIf="item.data?.appointmentType as id">
                {{preAppointmentTypes[id]?.title | titlecase}}
              </span>
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              <span *ngIf="item.data?.spaceType as id">
                {{preSpaceTypes[id]?.title | titlecase}}
              </span>
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.data?.miles ? (item.data.miles | number:'1.2-2') + ' mi' : '' }}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.data?.additionalPassenger}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.data?.privateNotes}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.data?.generalNotes}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{(item.data?.requesterName) | titlecase}}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{item.reason}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>